<template>
  <b-card header-tag="header" class="m-3" no-body>
    <template #header>
      <header-sagres titulo="Emendas" :botoes="botoesHeader" breakpoint="xl" />
    </template>
    <b-card-body>
      <CardFiltrosBusca>
        <b-form @submit.prevent="aplicarFiltros" @reset.prevent="limparFiltros">
          <b-row>
            <b-col cols="12" sm="6">
              <default-form-validation-provider
                label="Número"
                rules=""
                v-slot="defaultState"
              >
                <b-form-input
                  id="input-numero-emenda"
                  v-model="filtros.NrEmenda"
                  :state="defaultState.state"
                  type="number"
                  min="1"
                />
              </default-form-validation-provider>
            </b-col>
            <b-col cols="12" sm="6">
              <default-form-validation-provider
                label="Ano"
                rules=""
                v-slot="defaultState"
              >
                <b-form-input
                  id="input-ano-emenda"
                  v-model="filtros.Ano"
                  :state="defaultState.state"
                  type="number"
                  min="1950"
                  max="2100"
                />
              </default-form-validation-provider>
            </b-col>
            <b-col cols="12" sm="6">
              <default-form-validation-provider
                label="Autor(a)"
                rules=""
                v-slot="defaultState"
              >
                <b-overlay :show="loadingAutores">
                  <b-form-select
                    id="autor"
                    :state="defaultState.state"
                    :options="listaAutores"
                    v-model="filtros.Autor"
                  />
                </b-overlay>
              </default-form-validation-provider>
            </b-col>
            <b-col cols="12" sm="6">
              <default-form-validation-provider
                rules=""
                v-slot="defaultState"
                label="Tipo da Emenda"
              >
                <b-overlay :show="loadingTiposEmendas">
                  <b-form-select
                    id="tipo-emenda"
                    :state="defaultState.state"
                    :options="listaTiposEmenda"
                    v-model="filtros.TipoEmenda"
                  />
                </b-overlay>
              </default-form-validation-provider>
            </b-col>
            <b-col cols="6" xl="3" offset-xl="3">
              <b-button type="reset" variant="outline-secondary">
                <font-awesome-icon icon="redo" class="mr-3" />
                Limpar
              </b-button>
            </b-col>
            <b-col cols="6" xl="3">
              <b-button
                type="submit"
                :disabled="tableBusy || loadingTiposEmendas || loadingAutores"
              >
                <font-awesome-icon icon="search" class="mr-3" />
                Filtrar
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </CardFiltrosBusca>
      <b-table
        id="emendasTable"
        :fields="fields"
        :items="items"
        :busy="tableBusy"
        :current-page="currentPage"
        :filter="filter"
        hover
        no-border-collapse
        sort-by=""
        :sort-desc="true"
        striped
        stacked="xl"
        show-empty
      >
        <template #empty>
          <span>Não foram encontrados dados.</span>
        </template>
        <template #emptyfiltered>
          <span>Não foram encontrados dados.</span>
        </template>
        <template #table-busy>
          <div class="text-center text-dark">
            <b-spinner class="align-middle" />
            <strong class="loading-text">Carregando...</strong>
          </div>
        </template>
        <template #cell(FlAtivo)="row">
          <b-badge
            class="emenda-status-badge"
            :class="{ 'is-inactive': !isEmendaAtiva(row.item.FlAtivo) }"
          >
            {{ isEmendaAtiva(row.item.FlAtivo) ? "Ativa" : "Inativa" }}
          </b-badge>
        </template>
        <template v-slot:cell(actions)="row">
          <b-dropdown class="d-md-none" right no-caret>
            <template #button-content>
              <font-awesome-icon icon="bars" />
            </template>
            <b-dropdown-item @click="detalhesEmenda(row.item.IdEmenda)">
              <font-awesome-icon icon="eye" />
              <span>Detalhes</span>
            </b-dropdown-item>
            <b-dropdown-item @click="editarEmenda(row.item.IdEmenda)">
              <font-awesome-icon icon="edit" />
              <span>Editar</span>
            </b-dropdown-item>
            <b-dropdown-item @click="alertaRemove(row.item)">
              <font-awesome-icon icon="trash" />
              <span>Excluir</span>
            </b-dropdown-item>
          </b-dropdown>
          <div
            class="actions-icons lgvert d-none d-md-flex justify-content-center"
          >
            <b-link
              class="text-dark"
              @click="detalhesEmenda(row.item.IdEmenda)"
            >
              <font-awesome-icon icon="eye" />
              <div style="font-size: 12px">Detalhes</div>
            </b-link>
            <b-link class="text-dark" @click="editarEmenda(row.item.IdEmenda)">
              <font-awesome-icon icon="edit" />
              <div style="font-size: 12px">Editar</div>
            </b-link>
            <b-link class="text-dark" @click="alertaRemove(row.item)">
              <font-awesome-icon icon="trash" />
              <div style="font-size: 12px">Excluir</div>
            </b-link>
          </div>
        </template>
      </b-table>
      <table-pagination
        v-if="totalRows"
        :total-rows="totalRows"
        :per-page="pageSize"
        @pageChange="pageChange"
      />
    </b-card-body>
  </b-card>
</template>

<script lang="ts">
import HeaderSagres from "@/components/shared/HeaderSagres.vue";
import { BotaoSagres } from "@/types/botao-sagres";
import { TableField } from "@/types/table-field";
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { Component, Vue } from "vue-property-decorator";
import { fieldsEmendas } from "@/types/entregas/emendas/fields-emendas";
import emendaService from "@/services/entregas/emendaService";
import { SelectValue } from "@/types/select-value";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";
import CardFiltrosBusca from "@/components/shared/CardFiltrosBusca.vue";
import { EmendaResumida } from "@/types/entregas/emendas/emenda-resumida";
import autorService from "@/services/administracao/autorService";
import TablePagination from "@/components/atos-pessoal/TablePagination.vue";

const CompProps = Vue.extend({
  name: "Consultar",
  components: {
    HeaderSagres,
    DefaultFormValidationProvider,
    CardFiltrosBusca,
    TablePagination,
  },
});

@Component
class ConsultarEmendas extends mixins(UtilsTS, CompProps) {
  botoesHeader: BotaoSagres[] = [
    {
      id: 1,
      icone: "plus",
      texto: "Criar Emenda",
      url: `/entrega/editar-emendas`,
    },
  ];

  fields: TableField[] = fieldsEmendas;
  items: EmendaResumida[] = [];

  filter = "";
  currentPage = 1;
  pageSize = 10;
  totalRows = 0;

  tableBusy = false;
  loadingTiposEmendas = true;
  loadingAutores = true;

  filtros = {
    NrEmenda: null,
    Ano: null,
    Autor: null,
    TipoEmenda: null,
  };

  listaTiposEmenda: SelectValue[] = [];
  listaAutores: SelectValue[] = [];

  async created() {
    this.getListaAutores();
    this.getListaTiposEmenda();
    this.aplicarFiltros();
  }

  async pageChange(value: number) {
    this.currentPage = value;
    await this.filtrarEmendas();
  }

  async aplicarFiltros() {
    await this.pageChange(1);
  }

  async getListaTiposEmenda() {
    try {
      this.loadingTiposEmendas = true;
      const response = await emendaService.getTiposEmenda();
      this.listaTiposEmenda = response.map(
        (i: { Id: number; Descricao: string }) => {
          return { text: i.Descricao, value: i.Id };
        }
      );
      this.listaTiposEmenda.unshift({
        value: null,
        text: "Selecione o tipo da emenda",
      });
    } catch (error: unknown) {
      this.tratarError(error);
    } finally {
      this.loadingTiposEmendas = false;
    }
  }

  async getListaAutores() {
    try {
      this.loadingAutores = true;
      const autores = await autorService.getAutores();
      this.listaAutores = autores.map((a) => {
        return { value: a.IdAutor, text: a.NmAutor };
      });
      this.listaAutores.unshift({ value: null, text: "Selecione o autor(a)" });
    } catch (error: unknown) {
      this.tratarError(error);
    } finally {
      this.loadingAutores = false;
    }
  }

  editarEmenda(idEmenda: number) {
    if (idEmenda) {
      try {
        return this.$router.push({
          name: `editar--emendas`,
          params: { idEmenda: String(idEmenda), isDetalhe: "" },
        });
      } catch (e: unknown) {
        console.error(e);
        this.tratarError(e);
        return;
      }
    }
    return this.$toast.error(`Erro ao obter dados de Usuario`);
  }

  detalhesEmenda(idEmenda: number) {
    return this.$router.push({
      name: `editar--emendas`,
      params: { idEmenda: String(idEmenda), isDetalhe: String(true) },
    });
  }

  async excluirEmenda(emenda: EmendaResumida) {
    try {
      await emendaService.removeEmenda(emenda.IdEmenda);
      return this.$toast.success(
        `Emenda ${emenda.NrEmenda}/${emenda.NrAnoEmenda} excluída com sucesso!`
      );
    } catch (error: unknown) {
      this.tratarError(error);
    } finally {
      await this.filtrarEmendas();
    }
  }

  alertaRemove(emenda: EmendaResumida) {
    this.$bvModal
      .msgBoxConfirm(
        `Deseja excluir a emenda ${emenda.NrEmenda}/${emenda.NrAnoEmenda}?`,
        {
          buttonSize: "sm",
          cancelTitle: "Cancelar",
          cancelVariant: "outline-secondary",
          okVariant: "secondary",
          centered: true,
          headerBgVariant: "secondary",
          headerTextVariant: "light",
          okTitle: "Confirmar",
          title: "Exclusão de Emenda",
        }
      )
      .then(async (value) => {
        if (value) await this.excluirEmenda(emenda);
      })
      .catch((err) => {
        console.error(`Erro ao operar o dialog de alerta de excluir`, err);
      });
  }

  async filtrarEmendas() {
    try {
      this.tableBusy = true;
      const response = await emendaService.getEmendas(
        this.currentPage,
        this.filtros.NrEmenda,
        this.filtros.Ano,
        this.filtros.Autor,
        this.filtros.TipoEmenda
      );
      if (!response)
        return this.$toast.error("Erro ao obter a lista de emendas");
      this.items = response.emendas;
      this.totalRows = response.totalRows;
      this.pageSize = response.pageSize || 10;
      this.currentPage = response.page || this.currentPage;
    } catch (error: unknown) {
      this.items = [];
      this.totalRows = 0;
      this.tratarError(error);
    } finally {
      this.tableBusy = false;
    }
  }

  isEmendaAtiva(val: unknown): boolean {
    if (val === true || val === 1 || val === "1") return true;
    if (val === "S" || val === "Sim" || val === "true") return true;
    return false;
  }

  limparFiltros() {
    this.filtros = {
      NrEmenda: null,
      Ano: null,
      Autor: null,
      TipoEmenda: null,
    };
    this.aplicarFiltros();
  }
}

export default ConsultarEmendas;
</script>
  <style scoped>
.emenda-status-badge {
  background-color: var(--baseColor);
  color: #fff;
  font-weight: 600;
}
.emenda-status-badge.is-inactive {
  background-color: #e9ecef;
  color: var(--baseColor);
  border: 1px solid var(--baseColor);
}
</style>
